import React from "react"
import { Spin } from "antd"

export const LoadingUser = () => {
  return <Spin className="middle" size="large" />
}
